<template>
  <ui-modal
    :show="showAmount"
    type="tag"
    title="领取奖励"
    iconType="gift_2"
    @close="showAmount = false"
  >
  <div class="task">
    <ul class="task-box">
      <li class="item" v-for="(value, index) in listData" :key="index">
        <div class="item-left">
          <div class="item-icon" >
            <div class="icon" :style="{'background-image': `url(${value.imgUrl})`}"></div>
            <div class="tip">
              <div class="label-box">
                <span class="label-shadow">{{ value.coins }}</span>
                <span class="label-text">{{ value.coins }}</span>
              </div>
            </div>
          </div>
          <div class="title">
            {{ value.title }}
          </div>
        </div>

        <div class="item-right">
          <span class="time-target">
            ({{ value.progress }} / {{ value.progressTotal }})
          </span>
          <button
            class="button-status"
            :class="classMode[value.status]"
            @click="handleStatusClick(value.status, value, index)"
          >
            <ui-frame-bg :colorType="colorMode[value.status]">
              <div class="label-box">
                <span class="label-shadow">{{ statusMode[value.status] }}</span>
                <span class="label-text">{{ statusMode[value.status] }}</span>
              </div>
            </ui-frame-bg>
          </button>
        </div>
        <!-- {{ value }} -->
      </li>
    </ul>
  </div>
    

    <Prompt ref="prompt" hook="px"></Prompt>
  </ui-modal>
</template>

<script>
import * as api from '@/service/index'
import { mapState, mapActions, mapMutations } from 'vuex'
import Prompt from '@/components/prompt1'
import UiModal from '@/components/ui-modal.vue'
import uiFrameBg from '@/components/ui-frame-bg'

export default {
  components: {
    Prompt,
    UiModal,
    uiFrameBg
  },

  props: {},
  data() {
    return {
      classMode: ['undone', 'receive', 'received'],
      statusMode: ['未完成', '领取', '已领取'],
      colorMode: ['gray-light', 'yellow', 'gray'],
      showAmount: false,
      info: {},
      inRequest: false,
      listData: [],
      padlock :false
    }
  },
  computed: {
    ...mapState(['token'])
  },

  mounted() {
   
  },
  methods: {
    ...mapActions(['reqUserInfo','reqRedDotState']),
    ...mapMutations(['SET_SHOWLINGQU']),
    hideModal() {
      this.showAmount = false
    },

    handleStatusClick(status, value,index) {
      if(!this.padlock){
        this.padlock = true
        if (status === 1) {
          this.listData[index].status = 2
        }
        this.statusClick(status, value)
        this.padlock = false
      }
      
    },
    getAmount() {
      this.fetchActivityList()
      this.showAmount = true
      // 埋点
      if (typeof tapdb == 'undefined') return
      tapdb.trackEvent('点击领取奖励')
    },

    hasAgeValue(arr, targetValue) {
      return arr.some((obj) => obj.status == targetValue)
    },

    // 每日任务
    async fetchActivityList() {
      try {
        if(!this.token) return;
        const res = await api.getTaskList(this.token)
        // console.log('res', res)
        // console.log('res', res)
        if (res.status === 200) {
          // console.log('ressss', res)
          const { dailyTasks } = res.data
          this.listData = dailyTasks
          
        }
      } catch (err) {
        console.log(err)
      }
    },

    async statusClick(status,value) {
      if (this.classMode[status] == 'receive' && !this.inRequest) {
        this.inRequest = true
          let data = {
             taskId: value.id
          }
          if(!this.token) return;
          let response = await api.getActivityReward(this.token, data)
          // console.log('response', response)
          if (response.status == 200 && response.data === true) {
           
            this.fetchActivityList()
            this.reqRedDotState()
            const  now = await api.reqcurrentTime()
            if(value.isSend){
              if(!this.token) return;
              const res= await api.reqGiftList({token: this.token,force : true})
              if(res.status === 200){
                res.data?.find(item => {
                  if(typeof tapdb == 'undefined') return;
                  if(item.giftId == 'xc006'){
                    if(now.status == 200){
                      const countdown = this.formatDay(now.data)
                      // 领取任务奖励
                      // console.log(value.id +"+"+countdown)
                        tapdb.trackEvent("领取奖励", {
                        '#mission_unique_id': value.id +"+"+countdown,
                         // 获得道具余量 
                        '#prop_after': item.count,
                          // 获得物品数量
                         '#item_gain': +value.coins,
                           // 物品id
                          '#prop_id': item.giftId,
                           // 道具获得的原因
                          '#prop_type':value.title,
                        });
                    }
                   
    
                  }
                })
              }
             
            }else{
              this.reqUserInfo(true)
              if(now.status == 200){
                if(typeof tapdb == 'undefined') return;
                const countdown = this.formatDay(now.data)
                // 领取任务奖励 货币
                // 埋点描述
                  tapdb.trackEvent("领取奖励", {
                    // 埋点行为，领取任务
                  '#mission_unique_id': value.id +"+"+countdown,
                  // 本次货币变化
                  '#value_change': +value.coins,
                  // 变化余量
                  '#value_after': +this.amount.quizRemainNum,
                  // 任务id
                  '#coin_id': value.id,
                  // 任务描述
                  '#via_type':value.desc,
                });
              }
            }
            this.inRequest = false
            this.$refs.prompt.setMsg('领取成功～')
          } else {
            this.$refs.prompt.setMsg(response.data)
          }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/quiz/amount';
</style>